import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PORTFOLIO_IMAGES } from "../lib/content";

const CATEGORIES = [
  { id: "", label: "All" },
  { id: "branding", label: "Branding" },
  { id: "campaign", label: "Campaign" },
  { id: "creative_direction", label: "Creative Direction" },
  { id: "event", label: "Events" },
  { id: "production", label: "Production" },
  { id: "conference", label: "Conference" },
];

const FALLBACK = PORTFOLIO_IMAGES.map((src, i) => ({
  _id: `f-${i}`,
  title: ["Vision Campaign", "Editorial Direction", "Executive Identity", "Conference Production", "Brand Architecture", "Public Image Refresh"][i],
  client: ["Atlas Foundation", "Sovereign Media", "Coastal Executive", "Hampton Roads Summit", "Pinnacle Group", "Public Figure"][i],
  category: ["campaign", "creative_direction", "branding", "conference", "branding", "creative_direction"][i],
  description: "Editorial direction, narrative architecture, and full production stewardship.",
  cover_image_url: src,
  year: "2025",
}));

export default function PortfolioPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  useEffect(() => {
    api.get("/portfolio", { params: filter ? { category: filter } : {} })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, [filter]);
  const list = items.length ? items : FALLBACK.filter((f) => !filter || f.category === filter);

  return (
    <div data-testid="portfolio-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-28 md:pt-40 pb-10">
        <div className="eyebrow text-[var(--crest-gold)]">— Portfolio</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight mt-6 leading-[1.02] max-w-3xl">
          Selected work from the studio.
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-6">
        <div className="flex flex-wrap gap-3" data-testid="portfolio-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c.id || "all"}
              onClick={() => setFilter(c.id)}
              className={`text-[11px] tracking-[0.28em] uppercase px-4 py-2 border transition-colors ${
                filter === c.id
                  ? "bg-[var(--crest-black)] text-[var(--crest-cream)] border-[var(--crest-black)]"
                  : "border-black/15 hover:border-[var(--crest-gold)] hover:text-[var(--crest-gold)]"
              }`}
              data-testid={`filter-${c.id || "all"}`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {list.map((p, i) => (
            <div
              key={p._id || i}
              className={`group ${i % 4 === 1 ? "md:translate-y-10" : ""} ${i % 4 === 3 ? "md:-translate-y-6" : ""}`}
              data-testid={`portfolio-item-${i}`}
            >
              <div className="aspect-[3/4] overflow-hidden bg-black">
                <img src={p.cover_image_url} alt={p.title} className="luxe-img w-full h-full object-cover" />
              </div>
              <div className="pt-5">
                <div className="eyebrow text-[var(--crest-gold)]">{(p.category || "").replace(/_/g, " ")}</div>
                <div className="font-serif text-2xl mt-2">{p.title}</div>
                <div className="text-sm text-[var(--crest-muted)] mt-1.5">{p.client}{p.year ? ` · ${p.year}` : ""}</div>
                {p.description && <p className="text-sm text-[var(--crest-muted)] mt-3 leading-relaxed">{p.description}</p>}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
